export default __webpack_public_path__ + "static/media/chat.6a00fa6d.svg";